import * as angular from "angular";
import template from "./entity-users-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import type {
	EntityModel,
	EntityTypeConfig,
	EntityTypePermission
} from "./entityModalTabTypes";

export interface EntityUsersTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	permissions?: EntityTypePermission[];
}

// eslint-disable-next-line no-redeclare
export class EntityUsersTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const permission = this.permissions?.find(item => item.Code === this.typeConfig.Code);
		const canViewUsers = globs.entityTypes.byType(this.typeConfig.Code).users.read;
		this.tab = {
			name: "Users",
			code: "USERS",
			isAvailable: this.securityService.isActionOrPatternAllowed(canViewUsers)
				|| (permission?.Users !== undefined && !permission.Users.IsDisabled)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-users-tab", [])
	.component("entityUsersTab", {
		controller: EntityUsersTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			permissions: "<"
		}
	})
	.name;
